
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    // Use the context logout function
    logout();
  }, [logout]);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full bg-[#222222] p-8 rounded-lg text-center">
        <div className="mb-6">
          <img src="/lovable-uploads/c6149c28-8888-4f84-a284-90bb68c9f2d3.png" alt="Logo" className="h-10 mx-auto" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-4">Abmeldung erfolgreich</h1>
        <p className="text-gray-400 mb-8">Sie wurden erfolgreich vom System abgemeldet.</p>
        
        <Button 
          onClick={() => navigate("/login")} 
          className="w-full bg-[#41c7f0] hover:bg-[#3ab1d9] text-white"
        >
          <LogIn className="mr-2 h-4 w-4" />
          Erneut anmelden
        </Button>
      </div>
    </div>
  );
};

export default Logout;
